import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'servicesForCustomisation'
})
export class ServicesForCustomisationPipe implements PipeTransform {

  transform(value: any[]): string {
    if (!value || value.length === 0) {
      return '';
    }

    let result = '';
    const lastIndex = value.length - 1;

    value.forEach((item, index) => {
      result += item.service_name + ' x ' + item.total_completed_services_qty;
      if (index !== lastIndex) {
        result += ', ';
      }
    });
    
    return result;
  }
}
